/* =========================================================
   SHENHAIEX THEME — global JS
   Quick add to cart, cart count sync, toast, menu drawer, newsletter
   Works with both AJAX and native form submit fallbacks.
   ========================================================= */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var cartCountBadges = function () {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));
  };

  /* ----------- toast ----------- */
  function toast(title, msg, type) {
    if (window.shxToast) return window.shxToast(title, msg, type);
    var wrap = document.querySelector('.toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'toast-wrap';
      wrap.setAttribute('aria-live', 'polite');
      document.body.appendChild(wrap);
    }
    var el = document.createElement('div');
    el.className = 'toast' + (type === 'err' ? ' err' : '');
    el.innerHTML =
      '<div class="ti">' + (type === 'err' ? '⚠️' : '✅') + '</div>' +
      '<div><b>' + (title || '') + '</b><span>' + (msg || '') + '</span></div>';
    wrap.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'all .3s';
      el.style.opacity = 0;
      el.style.transform = 'translateX(30px)';
    }, 2700);
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 3100);
  }
  window.shxToast = toast;

  /* ----------- Klaviyo: Added to Cart event push ----------- */
  function klaviyoTrackAddToCart(item) {
    try {
      var _learnq = window._learnq;
      if (!_learnq || !item) return;
      _learnq.push(['track', 'Added to Cart', {
        '$value': item.price * (item.quantity || 1),
        'AddedItemProductName': item.name || '',
        'AddedItemProductID': item.productId || '',
        'AddedItemSKU': item.sku || '',
        'AddedItemImageURL': item.image || '',
        'AddedItemURL': item.url || '',
        'AddedItemPrice': item.price || 0,
        'AddedItemQuantity': item.quantity || 1,
        'ItemNames': item.name ? [item.name] : []
      }]);
    } catch (e) { /* Klaviyo not loaded — safe fail */ }
  }

  /* ----------- Quick add from product card ----------- */
  window.shxQuickAdd = function (productId, variantId, btnEl) {
    if (!variantId || !routes.cart_add_url) {
      toast('Variant missing', 'Open the product page to choose options.', 'err');
      return;
    }
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    btnEl = btnEl || document.body;
    btnEl.setAttribute('disabled', 'disabled');
    var original = btnEl.textContent;
    btnEl.textContent = 'Adding…';

    fetch(routes.cart_add_url, {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/javascript, application/json' }
    })
      .then(function (r) {
        return r.text().then(function (t) {
          try { return JSON.parse(t); } catch (e) { return t; }
        }).then(function (body) { return { ok: r.ok, status: r.status, body: body }; });
      })
      .then(function (res) {
        btnEl.removeAttribute('disabled');
        btnEl.textContent = original;
        if (!res.ok) {
          var msg = (res.body && res.body.description) || (res.body && res.body.message) || 'Could not add to cart';
          toast('Oops', msg, 'err');
          // fallback — jump to product URL
          var card = btnEl.closest && btnEl.closest('.p-card');
          if (card && card.dataset.productUrl) {
            setTimeout(function () { window.location.href = card.dataset.productUrl; }, 900);
          }
          return;
        }
        // Sync count: if response has item_count, use it; else +1
        var plus = 1;
        var parsed = res.body || {};
        try {
          if (parsed && typeof parsed.item_count === 'number') {
            cartCountBadges().forEach(function (b) { b.textContent = String(parsed.item_count); b.style.display = 'grid'; });
            plus = 0;
          }
        } catch (_) {}
        if (plus) {
          cartCountBadges().forEach(function (b) {
            var n = (parseInt(b.textContent || '0', 10) || 0) + 1;
            b.textContent = String(n);
            b.style.display = 'grid';
          });
        }
        toast('Added to Cart', 'Review your items in the cart.', 'ok');

        /* Klaviyo: Added to Cart */
        var card = btnEl.closest ? btnEl.closest('.p-card') : null;
        if (card) {
          klaviyoTrackAddToCart({
            productId: card.dataset.productId || '',
            sku: card.dataset.sku || '',
            name: card.dataset.productTitle || card.querySelector('.p-title') ? (card.querySelector('.p-title')||{}).textContent : '',
            image: card.dataset.productImage || '',
            url: card.dataset.productUrl || '',
            price: parseFloat((card.dataset.productPrice || '0').replace(/[^0-9.]/g, '')) || 0,
            quantity: 1
          });
        }
      })
      .catch(function () {
        btnEl.removeAttribute('disabled');
        btnEl.textContent = original;
        toast('Network error', 'Please try again in a moment.', 'err');
      });
  };

  /* ----------- Cart count live sync using cart.js ----------- */
  function syncCartCount() {
    if (!routes.root_url) return;
    fetch((routes.root_url.replace(/\/$/, '') || '') + '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { if (r.ok) return r.json(); }).then(function (c) {
      if (c && typeof c.item_count === 'number') {
        cartCountBadges().forEach(function (b) {
          b.textContent = String(c.item_count);
          b.style.display = c.item_count > 0 ? 'grid' : 'none';
        });
      }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCount);
  } else {
    syncCartCount();
  }

  /* ----------- Product form: AJAX add to cart + Buy Now ----------- */
  function bindProductForms() {
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.classList || !form.classList.contains('product-form')) return;
      var isBuyNow = form.classList.contains('buy-now');
      var submitBtn = form.querySelector('button[type="submit"][name="add"]');
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value || !routes.cart_add_url) return;
      if (isBuyNow) return; // native submit → Shopify buy now redirect
      ev.preventDefault();
      var data = new FormData(form);
      var qty = parseInt(data.get('quantity') || '1', 10) || 1;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.text = submitBtn.innerHTML; submitBtn.innerHTML = 'Adding…'; }
      fetch(routes.cart_add_url, {
        method: 'POST', body: data,
        headers: { Accept: 'application/json, application/javascript' }
      })
        .then(function (r) {
          return r.text().then(function (t) {
            try { return JSON.parse(t); } catch (e) { return t; }
          }).then(function (body) { return { ok: r.ok, body: body }; });
        })
        .then(function (res) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = submitBtn.dataset.text || 'Add to Cart'; }
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            toast('Oops', msg, 'err');
            form.submit();
            return;
          }
          if (res.body && typeof res.body.item_count === 'number') {
            cartCountBadges().forEach(function (b) {
              b.textContent = String(res.body.item_count);
              b.style.display = 'grid';
            });
          } else {
            cartCountBadges().forEach(function (b) {
              var n = (parseInt(b.textContent || '0', 10) || 0) + qty;
              b.textContent = String(n); b.style.display = 'grid';
            });
          }
          toast('Added to Cart', 'Item added successfully.', 'ok');

          /* Klaviyo: Added to Cart from PDP */
          klaviyoTrackAddToCart({
            productId: form.dataset.productId || '',
            sku: form.dataset.sku || (idInput.dataset.sku || ''),
            name: form.dataset.productTitle || (document.querySelector('h1.product-title')||{}).textContent || '',
            image: form.dataset.productImage || (document.querySelector('.product-main-image img')||{}).src || '',
            url: window.location.href,
            price: parseFloat(form.dataset.productPrice || '0') || 0,
            quantity: qty
          });
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; }
          form.submit();
        });
    });
  }
  bindProductForms();

  /* ----------- Mobile nav close on outside click ----------- */
  document.addEventListener && document.addEventListener('click', function (e) {
    var nav = document.getElementById('ShxNav');
    if (!nav || !nav.classList.contains('is-open')) return;
    var toggle = document.querySelector('.shx-mobile-toggle');
    if (!e.target.closest || (e.target.closest('#ShxNav') || e.target.closest('.shx-mobile-toggle'))) return;
    nav.classList.remove('is-open');
  });

  /* ----------- Price filter (collection) ----------- */
  document.addEventListener && document.addEventListener('DOMContentLoaded', function () {
    var min = document.getElementById('shx-price-min');
    var max = document.getElementById('shx-price-max');
    if (!min || !max) return;
    function rebuild() {
      // Filter rendered product cards by price on client side (best-effort).
      var lv = parseFloat(min.value) || -Infinity;
      var hv = parseFloat(max.value) || Infinity;
      var count = 0;
      document.querySelectorAll('.p-card').forEach(function (card) {
        var priceEl = card.querySelector('.price-item--regular, .now');
        if (!priceEl) { card.style.display = ''; count++; return; }
        var str = (priceEl.textContent || '').replace(/[^0-9.]/g, '');
        var n = parseFloat(str);
        var show = n >= lv && n <= hv;
        card.style.display = show ? '' : 'none';
        if (show) count++;
      });
      var cc = document.getElementById('shx-count');
      if (cc) cc.textContent = String(count);
    }
    [min, max].forEach(function (i) { i.addEventListener('input', rebuild); i.addEventListener('change', rebuild); });
  });

  /* ----------- Utility: escape ----------- */
  window.ShxTheme = {
    toast: toast,
    quickAdd: window.shxQuickAdd,
    syncCartCount: syncCartCount
  };
})();
